import { Box } from '@front10/base-elements';
import React from 'react';
import { useWeekDays } from '../i18n';
import WeekDay from './WeekDay';

export default function WeekDayNames(props: any) {
  const weekdays = useWeekDays();
  return (
    <Box className="calendar-days-title" role="row" {...props.weekDaysContainer}>
      {weekdays.map((offset) => {
        return <WeekDay key={`weekday-${offset}`} weekday={offset} {...props.weekdayItem} />;
      })}
    </Box>
  );
}
